import { render, staticRenderFns } from "./MainNavbarUserCard.vue?vue&type=template&id=f0663c06"
import script from "./MainNavbarUserCard.vue?vue&type=script&setup=true&lang=js"
export * from "./MainNavbarUserCard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports